// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 912) return "awsutilityVendor.2130429b0eecacf13d18.js";
	if (chunkId === 123) return "muiVendor.498a6d908346315848d1.js";
	// return url for filenames based on template
	return "chunk." + chunkId + ".js";
};